import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header';
import ChatMessage from '../ChatMessage';
import { fetchInterviewData } from '../../api/chat';
import { buildInterviewGreeting } from '../../utils/greeting';
import { 
  ChatContainerWrapper, 
  ChatMessages, 
  LoadingContainer,
  StartButton, 
} from './styles.js';
import { ClipLoader } from 'react-spinners';

const coach = {
  name: 'Rê',
  avatar: '/images/coach-profile.png',
};

const PublicChatContainer = ({ interview_uuid, talent_uuid }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [vacancyTitle, setVacancyTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [interviewData, setInterviewData] = useState(null);
  const chatMessagesEndRef = useRef(null);

  useEffect(() => {
    const getInterviewData = async () => {
      try {
        const data = await fetchInterviewData(interview_uuid, talent_uuid);
        setInterviewData(data);
        setVacancyTitle(data.vacancy_title);
        setCompanyName(data.company_name);
      } catch (error) {
        console.error('Error fetching interview data:', error);
      } finally {
        setLoading(false);
      }
    };

    getInterviewData();
  }, [interview_uuid, talent_uuid]);

  useEffect(() => {
    if (chatMessagesEndRef.current) {
      chatMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [interviewData]);

  return (
    <ChatContainerWrapper>
      <Header 
        vacancyTitle={vacancyTitle} 
        companyName={companyName}
      />
      {loading ? (
        <LoadingContainer>
          <ClipLoader color="#00BFFF" loading={loading} size={150} />
        </LoadingContainer>
      ) : !interviewData ? (
        <LoadingContainer>
          <h2 style={{ color: 'white' }}>Não foi possível obter a entrevista</h2>
        </LoadingContainer>
      ) : (
        <ChatMessages>
          <ChatMessage
            type="coach"
            text={buildInterviewGreeting(interviewData.talent_name, vacancyTitle, companyName)}
            user={coach}
            avatar={coach.avatar}
          />
          {interviewData.interview.map((item, index) => (
            <React.Fragment key={index}>
              <ChatMessage
                type="coach"
                text={item[`question_${index + 1}`].question}
                user={coach}
                avatar={coach.avatar}
              />
              <ChatMessage
                type="candidate"
                text={item[`question_${index + 1}`].answer}
                user={{ name: interviewData.talent_name }}
                avatar={interviewData.talent_photo_url}
                audioUrl={item[`question_${index + 1}`].audioUrl}
              />
            </React.Fragment>
          ))}
          <ChatMessage
            type="coach"
            text={interviewData.conclusion}
            user={coach}
            avatar={coach.avatar}
          />
          <ChatMessage
            type="coach"
            text={`Sua nota foi: ${interviewData.score}/100`}
            user={coach}
            avatar={coach.avatar}
          />
          <ChatMessage
            type="coach"
            text="Essa entrevista foi gerada pela Rê, a Inteligência Artificial da Recrutei! 😊"
            user={coach}
            avatar={coach.avatar}
          />
          <div ref={chatMessagesEndRef} />
          <div style={{ textAlign:'-webkit-center' }}>
            <a target='_blank' 
              style={{ textDecoration:'none' }}
              href='https://empregos.recrutei.com.br?utm_campaign=interview-public'>
                <StartButton>Conheça a Recrutei Empregos</StartButton>
            </a>
            <br></br>
            <p style={{ color:'white' }}>
            Este é um ambiente de treino, que utiliza a Rê (a inteligência artificial da Recrutei), e nenhuma das perguntas 
            realizadas foi previamente escolhida ou determinada pela empresa contratante. 
            </p>
          </div>
        </ChatMessages>
      )}
    </ChatContainerWrapper>
  );
};

export default PublicChatContainer;